//@ts-nocheck
async function upng_clearCart() {
  try {
    const req = await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST"
    });
    if(!req.ok) {
      console.error("Something went wrong clearing the cart.");
      console.error(req);
      return false;
    }
    // Cart cleared.
    return true;
  } catch(error) {
    console.error("Failed to clear the cart, ", error);
    return false;
  }
}

async function upng_localCheckoutBlocker(btn) {
  const notes = document.getElementById("cart-note")?.value;
  btn.disabled = true;
  btn.classList.add("is-loading");
  const blockResult = await upng_checkount_blocker(notes ? notes : "");
  const cart_items = document.querySelectorAll("cart-items-component");
  if(blockResult) {
    if(notes) notes.value = "";
    await upng_clearCart();
    btn.disabled = false;
    btn.classList.remove("is-loading");
    for(const section of cart_items) {
      await section.refresh();
    }
    const notif_result = document.getElementById("central-notif-result");
    if(notif_result) {
      notif_result.style.display = "block";
      console.log("Showing notification result...");
      notif_result.innerHTML = `<p class="upng-draft-order-success">${upng_checkout_blocker_locales.request_success}</p>`;
    }
  } else {
    btn.disabled = false;
    btn.classList.remove("is-loading");
    for(const section of cart_items) {
      await section.refresh();
    }
    const notif_result = document.getElementById("central-notif-result");
    if(notif_result) {
      notif_result.style.display = "block";
      console.error("Showing error...");
      notif_result.innerHTML = `<p class="upng-draft-order-failed">${upng_checkout_blocker_locales.request_failed}</p>`;
    }
  }  
}